import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { withCookies } from 'react-cookie';

import { inject, observer } from 'mobx-react'
import config from 'react-global-configuration';
import { PrimaryButton, Text, FullWidthWrapper, Heading2, Section, GridRow, Heading1 } from '../marketing/MarketingStyles';

import { trackEvent } from "../../utils/eventTracking"

@inject('utilStore', 'modalStore')
@observer
class RequestInformationSection extends Component {

  openModal = () => {
    this.props.modalStore.setState('request_information', true)
    trackEvent( 'Request Information - "Mehr Informationen" - CTA Section', 'Advertisment', 'Click Button' )
  }

  isInViewport = (offset = 0) => {
    if (!this.trigger) return false;
    const top = this.trigger.getBoundingClientRect().top;
    return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      if(!this.isInViewport() || this.props.cookies.get('hadRequestInformationSectionModalShown')) return

      this.props.modalStore.setState('request_information', true)
      this.props.cookies.set('hadRequestInformationSectionModalShown', true, { path: '/' });
    });
  }

  render() {

    const { partners } = this.props.utilStore.util

    return (
      <InfoSection>
        <InfoGrid desktop="2fr 1fr 2fr" tablet="1fr">
          <InformationWrapper>
            <Heading2>Mehr Informationen gefällig?</Heading2>
            <InformationText>
              Tauchen Sie ein in ein Netzwerk mit Persönlichkeiten aus der Wirtschaft, Politik, Medien und Sport und teilen Sie Ihre Begeisterung für Ihr Business und den Golfsport.
            </InformationText>
            <PrimaryButton value="Informationen Anfordern" onClick={ this.openModal } autoWidth />
          </InformationWrapper>
          <div></div>
          <InfoImage src="https://res.cloudinary.com/theloge/image/upload/w_500/q_auto:eco/v1627984734/marketing/will-porada-uy5ZEqUOscs-unsplash.jpg" />
        </InfoGrid>
        <div ref={ref => this.trigger = ref}></div>
      </InfoSection>
    )
  }
}

export default withCookies( RequestInformationSection )

const InformationWrapper = styled(FullWidthWrapper) `
  padding: 50px;

  ${cssVar.breakpoints.tablet} {
    padding: 30px;
  }
`

const InfoSection = styled(Section) `
  background: ${ cssVar.colors.lightest_grey };
  padding: 0;
  margin: 50px auto;
`

const InfoGrid = styled(GridRow) `
`

const InformationText = styled(Text) `
  padding-bottom: 30px;
`

const InfoImage = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: lightgrey;

  ${cssVar.breakpoints.tablet} {
    display: none;
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/RequestInformationSection.js